module.exports = __webpack_public_path__ + "img/slide_2.45bba205.jpg";